export const FEEDBACK_INTRO_TEXT =
  'مراجع گرامی،از اینکه مرکز ما را برای دریافت خدمات تشخیصی و تصویربرداری انتخاب کرده‌اید سپاسگزاریم.خواهشمند است جهت ارتقاء کیفیت خدمات، چند دقیقه از زمان خود را به تکمیل این فرم اختصاص دهید.اطلاعات شما کاملاً محرمانه بوده و صرفاً جهت بهبود خدمات استفاده خواهد شد.';

export const SERVICE_TYPES = [
  'MRI',
  'CT Scan',
  'سونوگرافی',
  'رادیولوژی',
  'ماموگرافی',
  'سایر',
] as const;

export type SurveyAnswerKey =
  | 'service_type'
  | 'visit_date'
  | 'q1'
  | 'q2'
  | 'q3'
  | 'q4'
  | 'q5'
  | 'q6'
  | 'q7'
  | 'q8'
  | 'q9';

export interface SurveyQuestionDef {
  id: SurveyAnswerKey;
  title: string;
  options: string[];
}

export const SURVEY_QUESTIONS: SurveyQuestionDef[] = [
  {
    id: 'q1',
    title: '1. نحوه برخورد و پاسخگویی کارکنان پذیرش',
    options: ['بسیار عالی', 'عالی', 'خوب', 'متوسط', 'ضعیف'],
  },
  {
    id: 'q2',
    title: '2. میزان نظم و سرعت انجام پذیرش',
    options: ['بسیار راضی', 'راضی', 'متوسط', 'ناراضی', 'بسیار ناراضی'],
  },
  {
    id: 'q3',
    title: '3. مدت زمان انتظار تا انجام تصویربرداری',
    options: ['بسیار مناسب', 'مناسب', 'متوسط', 'نامناسب', 'بسیار نامناسب'],
  },
  {
    id: 'q4',
    title: '4. رفتار و همکاری کارشناسان تصویربرداری',
    options: ['بسیار عالی', 'عالی', 'خوب', 'متوسط', 'ضعیف'],
  },
  {
    id: 'q5',
    title: '5. میزان توضیحات ارائه‌شده قبل از انجام تصویربرداری',
    options: ['کاملاً کافی', 'کافی', 'متوسط', 'ناکافی', 'کاملاً ناکافی'],
  },
  {
    id: 'q6',
    title: '6. نظافت و بهداشت محیط مرکز',
    options: ['بسیار عالی', 'عالی', 'خوب', 'متوسط', 'ضعیف'],
  },
  {
    id: 'q7',
    title: '7. کیفیت کلی خدمات ارائه‌شده',
    options: ['بسیار عالی', 'عالی', 'خوب', 'متوسط', 'ضعیف'],
  },
  {
    id: 'q8',
    title: '8. میزان رضایت کلی شما از مرکز',
    options: ['بسیار راضی', 'راضی', 'متوسط', 'ناراضی', 'بسیار ناراضی'],
  },
  {
    id: 'q9',
    title: '9. آیا این مرکز را به دیگران پیشنهاد می‌کنید؟',
    options: ['بله', 'خیر'],
  },
];

export const SURVEY_QUESTION_LABELS: Record<SurveyAnswerKey, string> = {
  service_type: 'نوع خدمت دریافت‌شده',
  visit_date: 'تاریخ مراجعه',
  q1: SURVEY_QUESTIONS[0].title,
  q2: SURVEY_QUESTIONS[1].title,
  q3: SURVEY_QUESTIONS[2].title,
  q4: SURVEY_QUESTIONS[3].title,
  q5: SURVEY_QUESTIONS[4].title,
  q6: SURVEY_QUESTIONS[5].title,
  q7: SURVEY_QUESTIONS[6].title,
  q8: SURVEY_QUESTIONS[7].title,
  q9: SURVEY_QUESTIONS[8].title,
};
